import React from "react";
import { Link } from "react-router-dom";
import { LineChart } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-[#0A1914] text-white mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <LineChart className="h-6 w-6 text-[#00B368]" />
            <span className="font-display text-lg">Electronics&#8209;Galore.com</span>
          </div>
          <p className="text-sm text-white/60 max-w-md leading-relaxed">
            Professional trading education since 2010. A+ rated with the Better Business Bureau.
            Our paying members are our CEO — every decision is voted on by course owners.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-[#00B368] mb-4">Explore</p>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/courses" className="hover:text-white transition-colors">Courses</Link></li>
            <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/members" className="hover:text-white transition-colors">Members Area</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-[#00B368] mb-4">Trust</p>
          <ul className="space-y-2 text-sm text-white/70">
            <li>In business 20+ years</li>
            <li>A+ BBB Rating</li>
            <li>Member-governed</li>
            <li>Weekly payouts, every Friday</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40 font-mono">
        © {new Date().getFullYear()} Electronics-Galore.com · Trading involves risk. Results vary by effort and consistency.
      </div>
    </footer>
  );
}
